import React from "react";
import AppModal from "../common/AppModal";
import UpdateCompanyForm from "../../forms/UpdateCompanyForm";
import { CompanyResponseDto } from "../../shared/dtos/company/CompanyResponseDto";

interface UpdateCompanyModalProps {
  open: boolean;
  onClose: () => void;
  company: CompanyResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateCompanyModal: React.FC<UpdateCompanyModalProps> = ({
  open,
  onClose,
  company,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Edit Company Information"
      width="md"
      loading={loading}
    >
      <UpdateCompanyForm company={company} loading={loading} error={error} />
    </AppModal>
  );
};

export default UpdateCompanyModal;
